import styled from "styled-components";


export const Container = styled.div`
    margin: 1rem 0;
    align-self: flex-start;
`;

export const Label = styled.p`
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
`;